export default __webpack_public_path__ + "static/media/05AW3JUL66.6ded1a8f.jpg";